const REDACTED = '[REDACTED]';

const SENSITIVE_PATTERNS: [RegExp, string][] = [
  // JWTs and Bearer tokens
  [/\beyJ[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]*/g, REDACTED],
  [/\b[Bb]earer\s+[A-Za-z0-9._~+/=-]{10,}/g, `Bearer ${REDACTED}`],
  // Email addresses
  [/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g, REDACTED],
  // Credit-card-like numbers (13–19 digits, optionally separated by dashes/spaces)
  [/\b(?:\d[ -]*?){13,19}\b/g, REDACTED],
  // Long hex strings / API keys (32+ hex chars)
  [/\b[0-9a-fA-F]{32,}\b/g, REDACTED],
  // Generic token/key/secret/password values in key=value or key:value pairs
  [
    /(?<=(?:token|key|secret|password|authorization|credential|session)[=: ]*)["']?[A-Za-z0-9._~+/=-]{8,}["']?/gi,
    REDACTED,
  ],
];

export function sanitizeString(value: string): string {
  let result = value;
  for (const [pattern, replacement] of SENSITIVE_PATTERNS) {
    result = result.replace(pattern, replacement);
  }
  return result;
}

export function sanitizeValue(value: unknown, depth = 0): unknown {
  if (depth > 10) return REDACTED;

  if (typeof value === 'string') {
    return sanitizeString(value);
  }
  if (Array.isArray(value)) {
    return value.map((item) => sanitizeValue(item, depth + 1));
  }
  if (value !== null && typeof value === 'object') {
    const sanitized: Record<string, unknown> = {};
    for (const key of Object.keys(value)) {
      sanitized[key] = sanitizeValue(
        (value as Record<string, unknown>)[key],
        depth + 1,
      );
    }
    return sanitized;
  }
  return value;
}
